// import { defineNuxtPlugin, useNuxtApp } from '#app';
import Endpoints from '../api/endPoints';
import Placebo from '../api/placebo';
function testWebP() {
  if (process.client) {
    return new Promise((res) => {
      const webP = new Image();
      webP.src =
        'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
      webP.onload = webP.onerror = () => {
        res(webP.height === 2);
      };
    });
  }
  return false;
}
function support_format_webp() {
  if (process.client) {
    var elem = document.createElement('canvas');

    if (!!(elem.getContext && elem.getContext('2d'))) {
      // was able or not to get WebP representation
      return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    } else {
      // very old browser like IE 8, canvas not supported
      return false;
    }
  }
  return false;
}
export default defineNuxtPlugin({
  dependsOn: ['auth-plugin'],
  name: 'api-plugin',
  async setup() {
    let webPSupported = (await testWebP()) || support_format_webp();
    const { $axios, $i18n, $store, $auth, $backendLink } = useNuxtApp();
    const tenantObj = useTenant();
    const endPoints = Endpoints(
      $axios,
      {
        localeProperties: { code: $i18n.locale.value },
      },
      $backendLink,
      $auth,
      async (a, b) => {
        return b();
      },
      $store,
      tenantObj,
    );
    const { data, error, status } = await useAsyncData('configs', async () => {
      return endPoints.getStructure(`configurations`, {}, null, true);
    });
    if (error && error.value) {
      console.error('error found loading configs');
    }
    return {
      provide: {
        api: {
          endPoints,
          placebo: Placebo(),
          tenant: null as any,
        },
        configsArray: data.value,
      },
    };
  },
});
